import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { SearchUserRequest, UsersQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../utils";

const USERS_QUERY = graphql(`
  query users($request: SearchUserRequest!) {
    users(SearchUserRequest: $request) {
      guid
      firstName
      lastName
      email
      active
    }
  }
`);

export type UserSearchResult = UsersQuery["users"][number];

/**
 * Searches users in the signed-in user's own company — app-service scopes the query to their
 * company, so there is nothing to pass for that. Pass filters to narrow it, e.g.
 * `{ isCompanyAdmin: true, active: true }` for the company's admins.
 */
export function useUsersGraphql(
  request: SearchUserRequest = {},
  options?: UseQueryOptions<UsersQuery, unknown, UsersQuery, QueryKey>,
) {
  // Under "users" so the user-update invalidations of ["users"] refresh it too.
  const { data, ...rest } = useGraphQlQuery(
    ["users", "search", request],
    USERS_QUERY,
    [{ request }],
    {
      ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
      ...options,
    },
  );

  return { data: data?.users, ...rest };
}
